import en from "./en.json";
import ru from "./ru.json";

export default {
  en: en,
  ru: ru,
};
